import React, { ReactElement } from "react";
import useRouting, { NavLink, useParams } from "../../contexts/Routing";

import PickRole from "./steps/pick-role";
import SecondStep from "./steps/select-type";
import { StepProps } from "./steps/base";

interface Step {
    id: string;
    step: (props: StepProps) => ReactElement;
    next?: string;
    previous?: string;
}
const STEPS: Step[] = [
    {
        id: "pick-role",
        step: PickRole,
        next: "second",
    },
    {
        id: "second",
        step: SecondStep,
        previous: "pick-role",
    },
];

/*

1. Pick a role,
2. Pick type of response
    2.1 If customer support, default to Threaded, Emoji or channel menu with correct descriptions of that use case.
    2,2 If IT, default to Threaded or Channel Menu with correct descriptions
3. Do you have a ticketing system already? (Connect to ZD, etc.)
4. Customize slack icon and stuff.

*/

export default function Onboarding() : ReactElement | null {
    const { Paths, createHistoryPush } = useRouting();

    const { stepId } = useParams(Paths.ONBOARDING_STEP);

    const stepIndex = (stepId ? STEPS.findIndex(current => current.id === stepId) : undefined) ?? 0;
    const step = STEPS[stepIndex];
    const Step = step.step;

    return (

        <div className="full-page">
            <div className="centered-container centered-container-lg pt-5 align-items-start">

                <Step onNext={
                    step.next
                        ? createHistoryPush(Paths.ONBOARDING_STEP, { stepId: step.next })
                        : createHistoryPush(Paths.AGENT)
                }
                />
                <div className="d-flex justify-content-between gap-4 mt-3 w-100">
                    {step.previous ? (
                        <NavLink
                            className="text-light text-center btn btn-link p-0 m-0 "
                            to={Paths.ONBOARDING_STEP}
                            params={{ stepId: step.previous }}
                        >
                            Back
                        </NavLink>
                    ) : (
                        <div />
                    ) }
                    <small className="text-light ">
                        {stepIndex + 1}
                        {" "}
                        /
                        {" "}
                        {STEPS.length}
                    </small>
                    <NavLink
                        className="text-light text-center btn btn-link p-0 m-0 "
                        to={Paths.AGENT}
                    >
                        Skip
                    </NavLink>

                </div>

            </div>
        </div>

    );
}
